"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertWorkScheduleSlotApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
exports.convertWorkScheduleSlotApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('agenda-slots'),
        attributes: zod_1.z.object({
            id: zod_1.z.string().uuid(),
        }),
    }),
});
